export const ordersReducer = (state = null, action) => (action.type === 'SET_ORDERS' ? action.orders : state);
